module.exports = __webpack_public_path__ + "img/4.369953f7.jpg";